import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const PipelineChart = ({ data, description }) => {
  // Data preparation for chart
  const pipelineData = () => {
    const stageOrder = ['Hired', 'Rejected'];
    
    return stageOrder.map(stage => ({
      name: stage,
      value: data.filter(candidate => candidate.stage === stage).length
    }));
  };

  return (
    <div className="dashboard-card p-6 slide-in-up" style={{animationDelay: '400ms'}}>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Hire Metrics</h3>
        <div className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Hiring Status
        </div>
      </div>
      {description && (
        <p className="text-sm text-gray-600 mb-4">{description}</p>
      )}
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={pipelineData()} layout="vertical" margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis type="number" tickLine={false} axisLine={false} style={{ fontSize: '12px' }} />
          <YAxis dataKey="name" type="category" tickLine={false} axisLine={false} style={{ fontSize: '12px' }} width={100} />
          <Tooltip 
            contentStyle={{ 
              borderRadius: '8px', 
              border: 'none', 
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              fontSize: '12px'
            }} 
          />
          <Bar 
            dataKey="value" 
            fill="#4f46e5" 
            name="Candidates"
            radius={[0, 4, 4, 0]}
            barSize={24}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PipelineChart;
